import React from 'react';
import styled from 'styled-components';

const BRAND_COLORS = {
  TELEGRAM: '#0088cc',
  WHATSAPP: '#25D366',
  VIBER: '#665CAC',
  MATRIX: '#0DBD8B',
};

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${(p) => BRAND_COLORS[p.$type] || 'var(--spark-color-text-muted)'};
  font-weight: 500;
`;

function TelegramIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={BRAND_COLORS.TELEGRAM}>
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  );
}

function WhatsAppIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={BRAND_COLORS.WHATSAPP}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function ViberIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={BRAND_COLORS.VIBER}>
      <path d="M11.404.016a17.14 17.14 0 0 0-1.734.108C4.722.852.859 5.467.11 10.948c-.264 1.984-.14 4.136.528 6.136.232.706.542 1.382.88 2.034.54 1.003.468 1.588-.156 2.504-.568.82-1.148 1.624-1.72 2.438-1.092 1.544-.404 2.824 1.128 2.94 1.788.148 3.688-.128 5.32-.852a4.9 4.9 0 0 0 1.14-.684c.956-.8 1.348-1.36 2.26-1.104 1.868.444 3.852.364 5.681-.304 2.793-.992 5.148-3.228 6.272-6.216.68-1.804.832-3.776.552-5.672C20.434 3.871 15.928.36 11.404.016zm.212 1.78c3.804.28 7.284 2.892 8.868 6.628 1.06 2.532 1.032 5.332-.172 7.8-1.504 3.096-4.476 5.264-7.852 5.82-1.628.268-3.372.112-4.944-.468-.584-.216-1.028-.468-1.448-.468-.48 0-.892.364-1.292.716-.62.54-1.216 1.116-1.912 1.564-.3.192-.636.248-.896.164-.312-.1-.408-.288-.24-.752.288-.8.664-1.556 1.004-2.328.26-.588.484-1.184.388-1.848-.004-.028-.016-.052-.016-.08-.072-.224-.264-.388-.4-.58a12.903 12.903 0 0 1-1.316-2.164c-.724-1.668-.944-3.544-.684-5.332.34-2.436 1.62-4.508 3.572-6.028a9.476 9.476 0 0 1 4.932-2.064c.328-.036.656-.048.984-.06l.08-.004zm2.08 3.832c-.196.004-.408.02-.612.04-.932.096-1.792.56-2.456 1.176-.648.6-1.128 1.44-1.128 2.36 0 .888.48 1.672 1.168 2.268a.928.928 0 0 0 1.1.072c.368-.236.444-.732.108-1.004-.316-.268-.48-.684-.408-1.124.088-.56.508-1.016 1.032-1.2.5-.164 1.032-.1 1.456.188.568.38.784 1.116.464 1.736-.02.028-.028.064-.044.096-.156.316-.12.624.112.808.396.316.84.508 1.32.604 1.208.252 2.376-.04 3.08-.852.324-.38.5-.852.48-1.344-.052-1.948-1.776-3.688-3.72-3.86-.224-.02-.448-.028-.668-.024z" />
    </svg>
  );
}

function ElementIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={BRAND_COLORS.MATRIX}>
      <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.314 4.715c3.289 0 5.956 2.66 5.956 5.943 0 .484-.394.877-.879.877s-.879-.393-.879-.877c0-2.313-1.88-4.189-4.198-4.189-.486 0-.879-.393-.879-.877s.392-.877.879-.877zm-5.092 9.504c-.486 0-.879-.394-.879-.877 0-3.283 2.666-5.945 5.956-5.945.485 0 .879.393.879.877s-.394.876-.879.876c-2.319 0-4.198 1.877-4.198 4.191 0 .484-.395.878-.879.878zm7.735 5.067c-3.29 0-5.957-2.662-5.957-5.944 0-.484.394-.878.879-.878s.879.394.879.878c0 2.313 1.88 4.189 4.199 4.189.485 0 .879.393.879.877 0 .486-.394.878-.879.878zm0-2.683c-.485 0-.88-.393-.88-.876 0-.484.395-.878.88-.878 2.318 0 4.199-1.876 4.199-4.19 0-.484.393-.877.879-.877.485 0 .879.393.879.877 0 3.282-2.667 5.944-5.957 5.944z" />
    </svg>
  );
}

const ICONS = {
  TELEGRAM: TelegramIcon,
  WHATSAPP: WhatsAppIcon,
  VIBER: ViberIcon,
  MATRIX: ElementIcon,
};

export default function MessengerIcon({ type, size = 16, showLabel = true }) {
  const Icon = ICONS[type];
  if (!Icon) return <span>{type}</span>;

  return (
    <IconWrapper $type={type}>
      <Icon size={size} />
      {showLabel && LABELS[type]}
    </IconWrapper>
  );
}

const LABELS = {
  TELEGRAM: 'Telegram',
  WHATSAPP: 'WhatsApp',
  VIBER: 'Viber',
  MATRIX: 'Element',
};

export { BRAND_COLORS };
